module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/385.8a4a5f12.png";